import store from "./index";

const state = {
    data: {},
    draftId: null,
    location: {}
}

const mutations = {
    SAVE_USER_DATA(state, userData) {
        state.data = userData;
    },
    CHANGE_USER_DRAFT_ID(state, payload) {
        state.draftId = payload;
    },
    SET_USER_LOCATION(state, payload) {
        state.location = payload;
    }
}

const actions = {
    async getUserLocation({ commit }) {
        await axios("/location").then(async(response) => {
            if (response && response.data) {
                response.data.country_code = localStorage.getItem("paybright-location-test") || response.data.country_code;
                await commit("SET_USER_LOCATION", response.data);
            }
        }).catch(() => {});
    },
    saveUserData({ commit }, userData) {
        commit("SAVE_USER_DATA", userData);
    },
    changeUserDraftId({ commit }, data) {
        commit("CHANGE_USER_DRAFT_ID", data);
    }
}

const getters = {
    // Todo: Refactor instead of importing the store, use the rootState (third paramenter)  in userShipping
    userShipping() {
        const countryCode = String(state.location.country_code).toLowerCase();
        const regionCode = String(state.location.region_code).toLowerCase();

        if (countryCode == "us" && ["ak", "hi"].includes(regionCode)) {
            return store.Application.state.shippingRates[`${countryCode}-${regionCode}`];
        } else if (Object.keys(store.Application.state.shippingRates).includes(countryCode)) {
            return store.Application.state.shippingRates[countryCode];
        } else {
            return store.Application.state.shippingRates["us"];
        }
    },
    userCurrency(state) {
        return state.location.country_code ==  "CA" ? "CAD" : "USD";
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}
